<div class="cf-flex-row cf-flex-wrap cf-justify-content-space-between cf-align-items-center">
  <form [formGroup]="filterForm" novalidate>
    <div class="filter-field">
      <mat-form-field appearance="outline" class="cf-flex cf-fill" data-test="SearchPhrase">
        <input
          type="text"
          matInput
          formControlName="searchPhrase"
          floatLabel="auto"
          [placeholder]="'UI.Common.Filter.Search' | translate"
          (blur)="search()"
        />
        <button mat-icon-button matSuffix (click)="search()">
          <mat-icon svgIcon="search"></mat-icon>
        </button>
      </mat-form-field>
    </div>
  </form>
</div>
